import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData, TabDevicesComponent } from '../tabs/tab-devices/tab-devices.component';
import { RegisteredDevice } from '../services/api-gateway.service';

@Component({
    selector: 'device-dialog',
    templateUrl: './device-dialog.component.html',
    standalone: false
})
export class DeviceDialogComponent {
  dialogType : 'update' | 'register';
  dialogDevice : RegisteredDevice;
  deviceForm = new FormGroup({
    description: new FormControl<string>('',[Validators.required,Validators.maxLength(64)]),
    lorawanAddress: new FormControl<string>('',[Validators.required,Validators.minLength(8),Validators.maxLength(8),Validators.pattern('[a-fA-F0-9]+')]),
    networkKey: new FormControl<string>('',[Validators.required,Validators.minLength(32),Validators.maxLength(32),Validators.pattern('[a-fA-F0-9]+')])
  });

  constructor(
    public dialogRef: MatDialogRef<TabDevicesComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
  ) {
    this.dialogType = dialogData.dialogType;
    this.dialogDevice = dialogData.deviceData;
    if (this.dialogType == 'update'){
      this.deviceForm.controls.description.setValue(dialogData.deviceData.description)
      this.deviceForm.controls.lorawanAddress.setValue(dialogData.deviceData.devaddr)
      this.deviceForm.controls.networkKey.setValue(dialogData.deviceData.network_key)
      this.deviceForm.controls.lorawanAddress.disable()
      this.deviceForm.controls.networkKey.disable()
    }
  }

  fakeNgModel(){
    // return form values to dialog data
    this.dialogDevice.description = <string>this.deviceForm.controls.description.value;
    this.dialogDevice.devaddr = <string>this.deviceForm.controls.lorawanAddress.value;
    this.dialogDevice.network_key = <string>this.deviceForm.controls.networkKey.value;
  }

  confirmDevice(){
    this.fakeNgModel();
    this.dialogRef.close(true);
  }

  cancelDevice(){
    this.dialogRef.close(false);
  }
}
